import React from 'react';
import Container from 'react-bootstrap/Container';
import { Row } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';

function LeaderInstructionsPage1() {
  return (
    <Container className="bg-white mt-2 mb-3 pb-4 candidate-profile-assessments">
      <Container className="m-auto w-75 p-0 pt-5">
        <h3>INSTRUCTIONS & OVERVIEW</h3>
        <div>
          Reading this will help you get the most from this report to not only help you grow and develop as a leader but
          also help your team boost performance and loyalty and critical business outcomes.{' '}
          <span className="emphasized-text">Please take the time to review this overview.</span>
        </div>
        <div className="pt-2">
          The Hutrics Leadership Report describes your strengths and developmental needs as a manager and leader. The
          report combines several different assessments (e.g., cognitive, behavioral, personality, values fit) using
          different sources of data (e.g., self-report, direct-report, comparison). The breadth of these assessments
          provides a holistic view of a leader that ultimately improves critical business outcomes. To achieve such
          outcomes, it is important for you to understand, own, and take action on this report (the report even provides
          proven action steps to get you started!).
        </div>
        <div className="pt-2">
          Below is an overview of each assessment and its purpose. After the overview, your scores are presented{' '}
          <span className="emphasized-text">
            (but don’t skip to the scores – you need to understand what the scores represent so you can take appropriate
            action).
          </span>
        </div>
        <h4 className="pt-4">PERSONALITY</h4>
        <div className="pt-1">
          The Hutrics Personality Inventory (HPI) is a self-report assessment consisting of four critical dimensions
          that have been proven to significantly impact a leader’s performance. Each of the four dimensions addresses a
          different component of leadership personality leading to enhanced outcomes. The table below defines each
          dimension of the Hutrics Personality Inventory.
        </div>
        <div className="pt-2" style={{ fontStyle: 'italic' }}>
          Primary Dimension Definitions:
        </div>
        <Row className="w-100 justify-content-center pt-3">
          <Stack direction="horizontal" style={{ height: '6em' }}>
            <div className="d-flex justify-content-end w-25 pb-3 pe-2 text-bold h-100">Humility</div>
            <div className="w-75 ps-2 pb-3 border-start border-1 border-dark h-100">
              The tendency to be humble, sincere, and generally modest with a very low sense of entitlement at work
              (high scores).
            </div>
          </Stack>
          <Stack direction="horizontal" style={{ height: '6em' }}>
            <div className="d-flex justify-content-end w-25 pb-3 pe-2 text-bold h-100">Emotionality</div>
            <div className="w-75 ps-2 pb-3 border-start border-1 border-dark h-100">
              The tendency to be calm, collected, and generally in control of one’s emotions with little fear, anxiety,
              and need for emotional support at work (high scores).
            </div>
          </Stack>
          <Stack direction="horizontal" style={{ height: '6em' }}>
            <div className="d-flex justify-content-end w-25 pb-3 pe-2 text-bold h-100">Sociability</div>
            <div className="w-75 ps-2 pb-3 border-start border-1 border-dark h-100">
              The tendency to have a general positive work outlook, have confidence in work settings, and typically
              experience positive feelings such as enthusiasm and energy while working (high scores).{' '}
            </div>
          </Stack>
          <Stack direction="horizontal" style={{ height: '6em' }}>
            <div className="d-flex justify-content-end w-25 pb-3 pe-2 text-bold h-100">Conscientiousness</div>
            <div className="w-75 ps-2 pb-3 border-start border-1 border-dark h-100">
              The tendency to be organized in one&apos;s work, dutiful and responsible, striving for accuracy and
              achievement, and deliberate in decision-making at work (high scores).{' '}
            </div>
          </Stack>
        </Row>
        <div className="pt-3 text-bold">Tips for Interpretation:</div>
        <div className="pt-2">A few things to consider when reading the Personality section of your report:</div>
        <ul>
          <li className="pt-2">
            There is no such thing as a &quot;good&quot; score. With each of the four personality dimensions, both
            positive and negative implications exist for high and low scores. While research does substantiate that
            certain factors are related to increased performance, a “perfect” personality profile does not exist. Thus,
            you should interpret your scores in terms of your own career aspirations and goals.
          </li>
          <li className="pt-2">
            It is possible to change your typical behavior, but any change depends on three things: knowing what you
            want to change, deciding to change it, and knowing how to change it. The information in this report will be
            helpful for your development in this regard.
          </li>
          <li className="pt-2">
            The results in this report are based on decades of application in organizations and leadership research.
          </li>
        </ul>
      </Container>
    </Container>
  );
}

export default LeaderInstructionsPage1;
